import {
  CART_GET_ASSETS,
  CART_ADD_ASSET,
  CART_REMOVE_ASSET,
} from '../actions/types';

const initialState = {
  assets: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case CART_GET_ASSETS:
      return { ...state, assets: action.payload };
    case CART_ADD_ASSET:
      if (action.payload) {
        return { ...state, assets: [...state.assets, action.payload] };
      }
      return state;

    case CART_REMOVE_ASSET:
      if (action.payload) {
        return {
          ...state,
          assets: state.assets.filter((id) => id !== action.payload),
        };
      }
      return state;

    default:
      return state;
  }
};
